/**
 * One party member's key: account and character together, since one
 * account can bring two characters. Party rows, roster slots and the
 * gathering scene all key members by it, so they must build it the same way.
 */
export function toRosterMemberKey(member: { readonly accountId: string; readonly characterId: string }): string {
    return `${member.accountId}:${member.characterId}`;
}
